import { PlanImageItem } from '../types';
import {api} from './api';

export const planImagesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		planImagesFindByPlanId: builder.query<PlanImageItem[], number>({
			query: (planId: number) => ({
				url: `planImages/findByPlanId/${planId}`,
				method: 'GET',
			}),
			providesTags: ['PlanImages'],
			transformResponse: (response: PlanImageItem[]) => response.sort((a, b) => a.rank - b.rank),
		}),
		planImagesFindByPlanIdPublic: builder.query<PlanImageItem[], number>({
			query: (planId: number) => ({
				url: `planImages/findByPlanIdPublic/${planId}`,
				method: 'GET',
			}),
			providesTags: ['PlanImagesPublic'],
		}),
		planImageDelete: builder.mutation<Pick<PlanImageItem, 'id'>, number>({
			query: (imageId) => ({
				url: `planImages/${imageId}`,
				method: 'DELETE',
			}),
			extraOptions: { maxRetries: 1 },
			invalidatesTags: ['PlanImages', 'PlanInfo'],
		}),
		planImageUpload: builder.mutation<PlanImageItem, {id: number, formData: FormData}>({
			query: (data) => ({
				url: `plans/${data.id}/uploadImage`,
				method: 'POST',
				body: data.formData,
			}),
			invalidatesTags: ['PlanImages', 'PlanInfo'],
		}),
		planImagesReorder: builder.mutation<Pick<PlanImageItem, 'id' | 'rank'>[], Pick<PlanImageItem, 'id' | 'rank'>[]>({
			query: (reorderedItems) => ({
				url: 'planImages/reorder',
				method: 'PUT',
				body: {
					images: reorderedItems
				},
			}),
			invalidatesTags: ['PlanImages', 'PlanInfo'],
		}),
	}),
});

export const { usePlanImageDeleteMutation, usePlanImageUploadMutation, usePlanImagesReorderMutation, usePlanImagesFindByPlanIdQuery, usePlanImagesFindByPlanIdPublicQuery } = planImagesApi;
